(function () {
  const deleteColorSchemes = (element) => {
    element.classList.forEach(className => {
      if (className.startsWith('color-background-') && className != 'color-background-overlay') {
        element.classList.remove(className);
      }
    });
  }

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector("details-modal.header__search");
    const searchModal = document.querySelector("details-modal.header__search > details");
    const allSubmenu = document.querySelectorAll(".header__submenu");
    const isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";
    const main = document.getElementById('MainContent')
    const sections = main.querySelectorAll('.shopify-section')
    const sectionFirstChildTransparent = sections[0]?.querySelector(
      '[data-header-transparent]'
    )
    const headerTransparent = header
    .querySelector('.header-wrapper')
    .classList.contains('header-wrapper--full-width')
    
    if (isLightLogo == 'true')
			header.classList.add('header--light-logo');
    else
      header.classList.remove('header--light-logo');

    if (!(sectionFirstChildTransparent && headerTransparent)) {
      deleteColorSchemes(header);
      header.classList.remove("color-background-overlay");
    }

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    /*const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty("--ann-height", `${entry.boundingClientRect.height}px`);
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });

    if (annBar) {
      annBarObserver.observe(annBar);
    } else {
      document.documentElement.style.setProperty("--ann-height", `0px`);
    }*/

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");
          document.querySelector('header.header').classList.add("menu-open");
          document.querySelector('.header__overlay').classList.add('active');

          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            document.querySelector('header.header').classList.remove("menu-open");
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
              //document.querySelector('.header__overlay').classList.remove('active');
            }
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
          document.querySelector('header.header').classList.add("menu-open");
        } else {
          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            el.classList.remove("list-menu--megamenu-visible");
            document.querySelector('header.header').classList.remove("menu-open");
            document.querySelector('.header__overlay').classList.remove('active');
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
          document.querySelector('header.header').classList.add("menu-open");
        }
      });
    });

    document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

    allSubmenu.forEach((submenu) => {
      const links = submenu.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");

      links.forEach((link) => {
        const childLinks = link.parentElement.querySelectorAll(".header__submenu-item--grandchild");

        link.addEventListener("mouseenter", (e) => {
          links.forEach((el) => {
            el.classList.add("header__submenu-item--inactive");
          });
          link.classList.remove("header__submenu-item--inactive");
        });

        childLinks.forEach((childLink) => {
          childLink.addEventListener("mouseenter", (e) => {
            childLinks.forEach((el) => {
              el.classList.add("header__submenu-item--inactive");
            });
            childLink.classList.remove("header__submenu-item--inactive");
          });
        });

        link.addEventListener("mouseleave", (e) => {
          childLinks.forEach((el) => {
            el.classList.remove("header__submenu-item--inactive");
          });
        });
      });

      submenu.addEventListener("mouseleave", (e) => {
        links.forEach((el) => {
          el.classList.remove("header__submenu-item--inactive");
        });
      });
    });

    menu?.addEventListener("mouseleave", (e) => {
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-item--inactive");
        link.classList.remove("list-menu-item--active");
        link.classList.remove("list-menu--megamenu-visible");
        document.querySelector('header.header').classList.remove("menu-open");
        document.querySelector('.header__overlay').classList.remove('active');
      });

      document.querySelectorAll(".header__submenu-item").forEach((link) => {
        link.classList.remove("header__submenu-item--inactive");
      })
    });

    if (header && header.classList.contains("color-background-overlay")) {
      const colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
      header.addEventListener("mouseenter", () => {
        header.classList.remove("color-background-overlay");
        /*if (colorScheme)
          header.classList.remove(colorScheme);*/
        deleteColorSchemes(header);
        header.classList.add("color-background-overlay-hidden");
      });

      header.addEventListener("mouseleave", () => { 
        if (!searchModal.hasAttribute("open")) {
          if (!header.classList.contains('shopify-section-header-sticky') 
            && !header.classList.contains('shopify-section-header-scroll')
            && !header.querySelector('.menu-drawer-container').classList.contains('menu-opening')
          ) {
            const main = document.getElementById('MainContent')
            const sections = main.querySelectorAll('.shopify-section')
            const sectionFirstChildTransparent = sections[0].querySelector(
              '[data-header-transparent]'
            )
            const headerTransparent = header
            .querySelector('.header-wrapper')
            .classList.contains('header-wrapper--full-width')
            
            if (sectionFirstChildTransparent && headerTransparent) {
              header.classList.add("color-background-overlay");
              if (colorScheme)
                header.classList.add(colorScheme);
            }
            header.classList.remove("color-background-overlay-hidden");
          }
        }
      });
    }

    if (header.querySelector('.header__submenu-button')) {
      header.querySelector('.js-open-list-menu-item').addEventListener('click', (event) => {
        const submenu = event.currentTarget.closest('.header__submenu');
        const items = submenu.querySelectorAll('.header__submenu-li');
        if (items) {
          items.forEach(item => {
            item.classList.add('active');
          })
        }

        event.currentTarget.parentElement.classList.add('hide');
      })
    }
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();

  document.querySelectorAll('.mega-menu__third-ul').forEach((innerMenu) => {
    innerMenu.querySelectorAll('li').forEach((li) => {
      li.addEventListener('mouseenter', function () {
        // Remove 'active' from all li in this parent ul
        innerMenu.querySelectorAll('li.active').forEach((activeLi) => {
          activeLi.classList.remove('active');
        });
        // Add 'active' to the hovered li
        this.classList.add('active');
      });
    });
  });
  
  document.querySelectorAll('.mega-menu__third-ul li').forEach(function(li) {
    li.addEventListener('mouseenter', function() {
      // Find the closest .mega-menu-items ancestor
      var megaMenuItems = li.closest('.mega-menu-items');
      if (megaMenuItems) {
        // Remove 'open' from all .menu-category_image inside this .mega-menu-items
        megaMenuItems.querySelectorAll('.menu-category_image.open').forEach(function(div) {
          div.classList.remove('open');
        });
        // Find the menu-category_image with matching data-title
        var dataTitle = li.getAttribute('data-title');
        if (dataTitle) {
          var matchDiv = megaMenuItems.querySelector('.menu-category_image[data-title="' + dataTitle + '"]');
          if (matchDiv) {
            matchDiv.classList.add('open');
          }
        }
      }
    });
  });

  // On hover of .mega-menu-list li, remove 'active' from all siblings and add to current
  // Only add hover for first-level children of .mega-menu-list, not for nested uls
  document.querySelectorAll('.mega-menu-list').forEach(function(ul) {
    // Only select direct li children (not nested li)
    ul.querySelectorAll(':scope > li').forEach(function(li) {
      li.addEventListener('mouseenter', function() {

        this.closest('.mega-menu-items').querySelectorAll('.menu-category_image.open').forEach(function(div) {
          div.classList.remove('open');
        });
        // Remove 'active' from all direct li children in this .mega-menu-list
        ul.querySelectorAll(':scope > li.active').forEach(function(activeLi) {
          activeLi.classList.remove('active');
        });
        // Add 'active' to the hovered li
        this.classList.add('active');
        
        // Check for data-title and find matching mega-menu__third-level
        var dataTitle = this.getAttribute('data-title');
        if (dataTitle) {
          // Find the closest .mega-menu-items ancestor
          var megaMenuItems = this.closest('.mega-menu-items');
          if (megaMenuItems) {
            // Remove 'open' from all .mega-menu__third-level inside this .mega-menu-items
            megaMenuItems.querySelectorAll('.mega-menu__third-level.open').forEach(function(div) {
              div.classList.remove('open');
            });
            // Find the mega-menu__third-level with matching data-title
            var matchDiv = megaMenuItems.querySelector('.mega-menu__third-level[data-title="' + dataTitle + '"]');
            if (matchDiv) {
              if(matchDiv.querySelectorAll('.mega-menu__third-ul li').length > 0){
                var getTab_title = matchDiv.querySelectorAll('.mega-menu__third-ul li')[0].getAttribute('data-title')
                if(document.querySelector('.menu-category_image[data-title="' + getTab_title + '"]')){
                  document.querySelector('.menu-category_image[data-title="' + getTab_title + '"]').classList.add('open');
                }
              }
              matchDiv.classList.add('open');
            }
          }
        }
      });
    });
  });


  // Add click event to .mobile-menu__nav-link to open corresponding panel by aria-controls
  document.querySelectorAll('.mobile-menu__nav-link[aria-controls]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default so menu will not close on click
      var panelId = this.getAttribute('aria-controls');
      if (panelId) {
        var panel = document.getElementById(panelId);
        if (panel) {
          // // Optionally, close other panels if needed
          // document.querySelectorAll('.mobile-menu__panel.is-open').forEach(function(openPanel) {
          //   if (openPanel !== panel) {
          //     openPanel.classList.remove('is-open');
          //   }
          // });
          panel.classList.add('is-open');
        }
      }
    });
  });

  // Add click event to .mobile-menu__back-button to close the closest .mobile-menu__panel
  document.querySelectorAll('.mobile-menu__back-button').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var panel = this.closest('.mobile-menu__panel');
      if (panel) {
        panel.classList.remove('is-open');
      }
    });
  });

})();

